<template>
  <div style="display: flex;justify-content: space-around">
    <el-checkbox
      v-model="job.mblOnly"
      :disabled="disabled"
      style="margin: 0"
      @change="onChange('mblOnly')"
    >{{ $t("SeaExport.DirectBusiness") }}
    </el-checkbox>
    <el-checkbox
      v-model="job.transfering"
      :disabled="disabled"
      style="margin: 0;padding-left: 5px"
      @change="onChange('transfering')"
    >{{ $t("SeaExport.Transport") }}
    </el-checkbox>
    <el-checkbox
      v-model="job.batch"
      :disabled="disabled"
      style="margin: 0;padding-left: 5px"
      @change="onChange('batch')"
    >{{ $t("SeaExport.InBatches") }}
    </el-checkbox>
    <el-checkbox
      v-model="job.salePrice"
      :disabled="disabled"
      style="margin: 0;padding-left: 5px"
      @change="onChange('salePrice')"
    >{{ $t("SeaExport.SpecialPrice") }}</el-checkbox>
    <el-checkbox
      v-model="job.allocation"
      :disabled="disabled"
      style="margin: 0;padding-left: 5px"
      @change="onChange('allocation')"
    >{{ "Allocation" }}
    </el-checkbox>
    <el-checkbox
      v-model="job.availableCabinSpace"
      :disabled="disabled"
      style="padding-left: 5px"
      @change="onChange('availableCabinSpace')"
    >{{ $t("CargoMsg.Cargo_AvailableCabinSpace") }}
    </el-checkbox>
  </div>
</template>

<script>
export default {
  name: 'SeBusinessTag',
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
